// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__17Jj7","filesListContainer":"PosDisputesFiles_filesListContainer__31HWW","filesButton":"PosDisputesFiles_filesButton__2FFK1"};